import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import * as Actions from '../../store/customers/grid/customers.grid.actions';
import { Button } from 'ui-components/components/button';
import { emptyObject } from 'ui-components/default-props/empty';

const CustomerNameLink = ({ className = '', customerDetails = emptyObject }) => {
  const { customerName, disabled, customerId } = customerDetails;
  const dispatch = useDispatch();
  const click = useCallback(
    (e) => {
      e.stopPropagation();
      dispatch(Actions.launchCustomerDetailModal(customerId));
    },
    [customerId, dispatch],
  );

  return (
    <Button className={className} disabled={disabled} onClick={click} theme='link'>
      {customerName}
    </Button>
  );
};

CustomerNameLink.propTypes = {
  className: PropTypes.string,
  customerDetails: PropTypes.shape({
    customerName: PropTypes.string.isRequired,
    customerId: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  }),
};

export default React.memo(CustomerNameLink);
